// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { ChangeBoardBackgroundColorsComponentView as ColorsView } from './ChangeBoardBackgroundColorsComponentView';
import { ChangeBoardBackgroundPhotosComponentView as PhotosView } from './ChangeBoardBackgroundPhotosComponentView';

import React from 'react';
import ReactDOM from '@trello/react-dom-wrapper';
import { View } from 'app/scripts/views/internal/view';
import xtend from 'xtend';
import { unsplashClient } from '@trello/unsplash';

const Component = {
  colors: ColorsView,
  photos: PhotosView,
};

// Get background prefs
const getBackgroundPrefs = function (prefs) {
  const out = {};
  for (const key in prefs) {
    const value = prefs[key];
    if (key.indexOf('background') > -1) {
      out[key] = value;
    }
  }
  return out;
};

class ChangeBoardBackgroundSelectView extends View {
  static initClass() {
    this.prototype.viewTitleArguments = {
      unsplashUrl: unsplashClient.attributionUrl,
    };

    this.prototype.className = 'board-menu-content-frame';
  }
  viewTitleKey() {
    if (this.options.component === 'colors') {
      return 'change background colors';
    } else {
      return 'change background photos';
    }
  }

  initialize() {
    this.listenTo(
      this.model,
      'change:prefs.background change:prefs.backgroundTile change:prefs.backgroundBrightness',
      this.frameDebounce(this.render),
    );
  }

  render() {
    const props = {
      boardId: this.model.id,
      backgroundPrefs: getBackgroundPrefs(this.model.attributes.prefs),
    };

    if (this.options.component === 'colors') {
      props.setBackgroundColor = (name, color, tracingCallbackArgs) => {
        this.model
          .set({
            prefs: xtend(this.model.get('prefs'), {
              background: name,
              backgroundColor: color,
              backgroundImage: null,
              backgroundImageScaled: null,
            }),
          })
          .setPrefWithTracing('background', name, tracingCallbackArgs);
      };
      props.setBackgroundGradient = (name, gradient, color) => {
        this.model
          .set({
            prefs: xtend(this.model.get('prefs'), {
              background: name,
              backgroundColor: color,
              backgroundImage: gradient,
              backgroundImageScaled: null,
            }),
          })
          .setPref('background', name);
      };
    }

    const Element = React.createElement(
      Component[this.options.component],
      props,
    );

    ReactDOM.render(Element, this.el);

    return this;
  }
}

ChangeBoardBackgroundSelectView.initClass();
export { ChangeBoardBackgroundSelectView };
